<main [@fadeInOut] role="main" id="main-heading" tabindex="0">
  <div  *ngIf="!loading" class="container-fluid">
    <div class="col-sm-11 center-block">
        <div class="row">
            <div class="col-sm-12">
                <h1 tabindex="0" aria-label="Product Portfolio" role="heading" aria-level="1">Product Portfolio</h1>
                <p role="paragraph" tabindex="0">
                  Find an existing product, or create a brand new product. Select a Product Name to open its product dashboard where you can access all SPL files or edit drug listing metadata.
                </p>
                <p id="demo"></p>
            </div>
        </div>
        <div class="row top-space">
            <div class="col-sm-12" aria-label="grid section">
                <nav ngbNav #ngbNav="ngbNav" [(activeId)]="activeTab" (navChange)="tabChanged($event)" tabindex="0" class="nav-tabs">
                    <ng-container ngbNavItem="LLFormGrid">
                        <a ngbNavLink>
                            <span aria-label="Products">Products ({{ count_LLForm }})</span>
                        </a>
                        <ng-template ngbNavContent tabindex="0" aria-label="LL form grid">
                            <div class="row bottom-padding">
                                <div class="col-sm-12" tabindex="0" aria-label="grid content">
                                  <ejs-tooltip #tooltip id="tooltip" (beforeRender)="tooltipValue($event)"  [enableHtmlParse]="false"  target=".e-tooltipcolumn">
                                    <ejs-grid id='LL_Form_Grid' #LLForm_grid
                                    [dataSource]='LLForm_grid_data'
                                    allowPaging='true'
                                    allowSorting='true'
                                    [pageSettings]='initialPage'
                                    height="570"
                                    (actionBegin)=begin($event)
                                    [toolbar]='toolbarOptions'
                                    allowScrolling="true"
                                    allowFiltering="true"
                                    (rowSelected)="llFormGridRowSelected($event)"
                                    (rowDeselected)="llFormGridRowDeselected($event)"                                    
                                    (toolbarClick)='toolbarClick($event)'
                                    [selectionSettings]="{ type: 'Single', persistSelection: true }">
                                      <e-columns>
                                        <e-column type="checkbox" width="40" *ngIf="hasDeletePermission"></e-column>
                                        <e-column field='llRevisionId'
                                                  isPrimaryKey="true"
                                                  [visible]="false"
                                                  [allowFiltering]="false"
                                                  [allowSorting]="false"></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='formName' headerText='Product Name' clipMode="EllipsisWithTooltip" width='200'>
                                          <ng-template #template let-data>
                                            <a class='pointer' (click)='viewFormOrGoToDashboard(data.llRevisionId, data.isDraftMode)'
                                               tabindex="0" role="link" aria-label="View Form or Dashboard" (keydown.enter)="viewFormOrGoToDashboard(data.llRevisionId, data.isDraftMode)">{{data.formName}}</a>
                                          </ng-template>
                                        </e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='proprietaryName' headerText='Proprietary Name' width='250' clipMode="EllipsisWithTooltip">
                                          <ng-template #template let-data>
                                            <span aria-label="cell for Proprietary Name" role="gridcell">{{toHtml(data.proprietaryName)}}</span>
                                          </ng-template>
                                        </e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='modifiedBy' headerText='Modified By' clipMode="EllipsisWithTooltip" width='190'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='modifiedDate' [allowFiltering]="false" headerText='Modified Date' type="date" [format]='formatOptions' clipMode="EllipsisWithTooltip" width='200'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='ndcPackageCode' headerText='NDC Package Code' clipMode="EllipsisWithTooltip" width='180'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='formVersion' headerText='Version' clipMode="EllipsisWithTooltip" width='110'>
                                          <ng-template #template let-data>
                                            {{data.isDraftMode ? 'Draft' : data.formVersion.toFixed(2) }}
                                          </ng-template>
                                        </e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='businessCategory' headerText='Business Category' clipMode="EllipsisWithTooltip" width='160'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='labelerName' headerText='Labeler Name' clipMode="EllipsisWithTooltip" width='190'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='productType' headerText='Product Type' clipMode="EllipsisWithTooltip" width='200'></e-column>
                                      </e-columns>
                          </ejs-grid>
                                  </ejs-tooltip>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                    <ng-container ngbNavItem="deliveries">
                        <a ngbNavLink>
                            <span aria-label="SPL Merge Deliveries">SPL Merge Deliveries ({{ dashboardDeliveriesData && dashboardDeliveriesData.length }})</span>
                        </a>
                        <ng-template ngbNavContent tabindex="0" aria-label="Deliveries grid">
                          <div [@fadeInOut] class="row bottom-padding">
                              <div class="col-sm-12" tabindex="0" aria-label="grid content">
                                <ejs-tooltip #tooltip id="tooltip" (beforeRender)="tooltipValue($event)" target=".e-tooltipcolumn" [enableHtmlParse]="false">
                                <ejs-grid id='deliveriesGrid' #deliveries_grid
                                [dataSource]='dashboardDeliveriesData'
                                allowPaging='true'
                                allowSorting='true'
                                [pageSettings]='initialPage'
                                height="570"
                                (actionBegin)=begin($event)
                                [toolbar]='toolbarOptions'
                                allowScrolling="true"
                                (queryCellInfo)='customizeCell($event)'
                                allowFiltering="true"
                                (rowSelected)="llDeliveriesGridRowSelected($event)"
                                (rowDeselected)="llFormGridRowDeselected($event)"                                
                                (toolbarClick)='toolbarClick($event)'
                                 [selectionSettings]="{ type: 'Single', persistSelection: true }">
                                  <e-columns>
                                    <e-column type="checkbox" width="40"></e-column>
                                    <e-column field='orderId'
                                              isPrimaryKey="true"
                                              [visible]="false"
                                              [allowFiltering]="false"
                                              [allowSorting]="false"></e-column>

                                    <e-column [customAttributes]="clipmodecolumn" field='statusDescription' headerText='Status' clipMode="EllipsisWithTooltip" width='160'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='formName' headerText='Form name' clipMode="EllipsisWithTooltip" width='220'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='downloadLink' headerText='File name' clipMode="EllipsisWithTooltip" width='220'>
                                      <ng-template #template let-data>
                                        <a *ngIf="data.taskStatusId === 3" class='pointer underline'
                                           (click)='downloadFile(data.filePath, data.fileName)' tabindex="0" role="link" aria-label="Download File"
                                           (keydown.enter)="downloadFile(data.filePath, data.fileName)"><i class="fas fa-download" aria-hidden="true"></i>  {{data.fileName}}</a>
                                        <i *ngIf="data.taskStatusId === 4">Not Available</i>
                                        <span *ngIf="data.taskStatusId === 1 || data.taskStatusId === 2">{{data.fileName}}</span>
                                      </ng-template>
                                    </e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='ndcPackageCode' headerText='NDC Package Code' clipMode="EllipsisWithTooltip" width='180'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='formVersion' headerText='Form version' type="number" format="N1" clipMode="EllipsisWithTooltip" width='130'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='externalTrackingNumber' headerText='Tracking number' clipMode="EllipsisWithTooltip" width='190'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='labelerCompanyName' headerText='Labeler company name' clipMode="EllipsisWithTooltip" width='210'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='productType' headerText='Product type' clipMode="EllipsisWithTooltip" width='190'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='modifiedBy' headerText='Modified by' clipMode="EllipsisWithTooltip" width='160'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='modifiedOn' headerText='Modified on' type="date" [allowFiltering]="false" [format]='formatOptions' clipMode="EllipsisWithTooltip" width='160'></e-column>
                                  </e-columns>
                      </ejs-grid>
                                </ejs-tooltip>
                              </div>
                          </div>
                        </ng-template>
                    </ng-container>
                </nav>
                <div [ngbNavOutlet]="ngbNav"></div>
            </div>
        </div>
    </div>
  </div>
  <div *ngIf="loading">
  <div id="loading"></div>
  </div>
  <div *ngIf="hasDeletePermission" class="col-sm-12 grid-actions" aria-label="delete button" tabindex="0">
      <app-delete-button class="hide-element" #deleteSPLButton
          [canDelete]="!!selectedLLRevisionId"
          [revisionId]="selectedLLRevisionId"
          [apiController]="'LLForms'"
          [isDraft]="selectedLLRevisionDraftMode">
      </app-delete-button>
   </div>

  <div class="sendToFDADiv hide-element" aria-label="send to FDA button" tabindex="0">
    <app-esig-modal #sendToFDAButton
                    [fileName]="'' + selectedLLRevisionFileName"
                    [documentType]="'' + selectedLLRevisionProductType"
                    [splVersionNumber]="'' + selectedLLRevisionVersion"
                    [formRevisionId]="'' + selectedLLRevisionId"
                    [orderId]="'' + selectedLLOrderId"
                  (isSuccessfulySubmitted)="onSubmitionToFDA($event)">
    </app-esig-modal>
  </div>
</main>
